import * as Form from '../../components/form'
import * as RasaInput from '../../components/rasa-input'
import * as LeadPostTypes from '../lead-posts/types'
import * as Types from './types'

import * as IsActive from '../../components/is_active'

export const UPDATE_SELECTED_DATE = IsActive.UPDATE_SELECTED_DATE

export const FETCH_CALENDAR_POSTS = 'FETCH_CALENDAR_POSTS'

export const FETCH_CALENDAR_LEAD_TEXT = 'FETCH_CALENDAR_LEAD_TEXT'

export const FETCH_CALENDAR_PROMOTIONS = 'FETCH_CALENDAR_PROMOTIONS'

export const UPDATE_CALENDAR = 'UPDATE_CALENDAR'

export const TITLE = 'TITLE'

export const CALENDAR_DATE_CHANGE = 'CALENDAR_DATE_CHANGE'

export const CALENDAR_SERVER_RESOURCE = '/content/calendar'

export const LEAD_POSTS_SERVER_RESOURCE = '/lead-posts'

export const LEAD_TEXT_SERVER_RESOURCE = '/lead-text'

export const PROMOTIONS_SERVER_RESOURCE = '/promotions'

export const UPDATE_CALENDAR_UPDATE_STATUS = 'UPDATE_CALENDAR_UPDATE_STATUS'

export const FEATURED_POST_FORM = 'FEATURED_POST_FORM'

export const ADD_LEAD_POST = 'ADD_LEAD_POST'

export const ADD_LEAD_TEXT_MODAL = 'ADD_LEAD_TEXT_MODAL'

export const UPDATE_LEAD_POST = 'UPDATE_LEAD_POST'

export const FeatureTypes = {
    Lead: 'Lead',
    Sponsored: 'Sponsored',
  }

export const FormFieldNames = {
    CategoryTypeId: 'category_type_id',
    Description: 'description',
    EndDate: 'end_date',
    FeatureType: 'feature_type',
    ImageUrl: 'image_url',
    Rank: 'rank',
    SiteName: 'site_name',
    StartDate: 'start_date',
    Title: 'title',
    Url: 'url',
  }

export const emptyFormField: LeadPostTypes.FormFields = {
    category_type_id: null,
    description: '',
    end_date: null,
    feature_type: FeatureTypes.Lead,
    image_url: '',
    rank: null,
    site_name: '',
    start_date: null,
    title: '',
    url: '',
}

export const FormValidators: Form.FormValidators = {
    [FormFieldNames.FeatureType]: RasaInput.validatePresent,
    [FormFieldNames.ImageUrl]: RasaInput.validateOptionalForgivingUrl,
    [FormFieldNames.Url]: RasaInput.validateForgivingUrl,
  }

export const emptyModalData: Types.ModalData = {
  showAddValidation: false,
}

export const EDIT_PROMOTION = 'EDIT_PROMOTION'
export const PUT_LEAD_TEXT = 'PUT_LEAD_TEXT'
export const POST_LEAD_TEXT = 'POST_LEAD_TEXT'
export const ADD_PROMOTION = 'ADD_PROMOTION'
export const TOGGLE_ADD_MENU = 'TOGGLE_ADD_MENU'
export const CALENDAR_SORT = 'CALENDAR_SORT'
export const CALENDAR_SORT_SORT_TABLE = 'CALENDAR_SORT_SORT_TABLE'
export const TOGGLE_RANK_MODAL = 'TOGGLE_RANK_MODAL'
export const TOGGLE_SORT_MENU = 'TOGGLE_SORT_MENU'

export const OPEN_SORT_MODAL = 'OPEN_SORT_MODAL'

export const JOB = 'Job'
export const WEBINAR = 'Webinar'
export const NATIVE = 'Native'
export const EVENT = 'Event'
export const PROMOTION = 'Promotion'
export const LEAD_TEXT = 'Lead Text'
export const CONTENT = 'Content'
export const SPONSORED = 'Sponsored'

export const SORTABLE_CATEGORIES = [
  JOB, WEBINAR, NATIVE, EVENT, CONTENT,
]

export const GUI_EDITOR = 'GUI'
export const RAW_EDITOR = 'RAW'

export const RESET_REORDERED_LEAD_POST = 'RESET_REORDERED_LEAD_POST'
export const SAVE_REORDERED_LEAD_POST = 'SAVE_REORDERED_LEAD_POST'

export const FETCH_LEAD_POSTS = 'FETCH_LEAD_POSTS'

export const FETCH_LEAD_POSTS_DRAG_CELL_REORDER = 'FETCH_LEAD_POSTS_DRAG_CELL_REORDER'
export const FETCH_LEAD_POSTS_DRAG_CELL_START = 'FETCH_LEAD_POSTS_DRAG_CELL_START'
export const FETCH_LEAD_POSTS_DRAG_CELL_END = 'FETCH_LEAD_POSTS_DRAG_CELL_END'



// WEBPACK FOOTER //
// ./src/pages/content-calendar/constants.ts